module.exports = "/_next/static/images/UseSegment-c9692791a19bf608ae5fb0dd7a7b36eb.webp";